<template>
  <v-row align="center">
    <v-col cols="12" md="3">
      <v-text-field
        label="Ancien mot de passe"
        prepend-icon="mdi-lock"
        :append-icon="show0 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show0 ? 'text' : 'password'"
        @click:append="show0 = !show0"
        :error-messages="oldPasswordErrors"
        @input="$v.oldPassword.$touch()"
        @blur="$v.oldPassword.$touch()"
        v-model="oldPassword"
        color="primary"
      />
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Nouveau mot de passe"
        prepend-icon="mdi-lock"
        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show1 ? 'text' : 'password'"
        @click:append="show1 = !show1"
        :error-messages="passwordErrors"
        @input="$v.password.$touch()"
        @blur="$v.password.$touch()"
        v-model="password"
        color="primary"
      />
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Confirmer"
        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show2 ? 'text' : 'password'"
        @click:append="show2 = !show2"
        prepend-icon="mdi-lock"
        :error-messages="confirmePasswordErrors"
        @input="$v.cPassword.$touch()"
        @blur="$v.cPassword.$touch()"
        v-model="cPassword"
        color="primary"
      />
    </v-col>
    <v-col cols="12" md="3">
      <v-btn outlined color="primary" @click="onChangeClicked">Changer</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";

import { validationMixin } from "vuelidate";
import { sameAs, minLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    oldPassword: { minLength: minLength(6) },
    password: { minLength: minLength(6) },
    cPassword: { sameAsPassword: sameAs("password") }
  },
  data() {
    return {
      show0: false,
      show1: false,
      show2: false,
      oldPassword: "",
      password: "",
      cPassword: ""
    };
  },
  methods: {
    ...mapActions(["updatePassword"]),
    onChangeClicked() {
      this.$v.$touch();
      if (!this.$v.$invalid)
        this.updatePassword({
          oldPassword: this.oldPassword,
          newPassword: this.password
        });
    }
  },
  computed: {
    // VALIDATION ERRORS
    oldPasswordErrors() {
      const errors = [];
      if (!this.$v.oldPassword.$dirty) return errors;
      !this.$v.oldPassword.minLength &&
        errors.push("le mot de passe doit être au minimum 6 caractéres");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push("le mot de passe doit être au minimum 6 caractéres");
      return errors;
    },
    confirmePasswordErrors() {
      const errors = [];
      if (!this.$v.cPassword.$dirty) return errors;
      !this.$v.cPassword.sameAsPassword &&
        errors.push("le mot de passe doit être identique.");
      return errors;
    }
  }
};
</script>